// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hx-6";
export var emphasizeQuantity = "_hx-3";
export var flatBottomCorners = "_hx-5";
export var productImage = "_hx-0";
export var quantityContainer = "_hx-2";
export var tooltip = "_hx-1";
export var wrapAndEllipsesOverflow = "_hx-4";